import { render } from "./HomeSkillBuilding.vue?vue&type=template&id=ec70e2c2&scoped=true"
import script from "./HomeSkillBuilding.vue?vue&type=script&lang=js"
export * from "./HomeSkillBuilding.vue?vue&type=script&lang=js"

import "./HomeSkillBuilding.vue?vue&type=style&index=0&id=ec70e2c2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec70e2c2"]])

export default __exports__